import React, { useState, useEffect } from "react";
import projectsData from "../../data/projects.json";
import "./DrawerProject.css";

const DrawerProject = ({ isOpen, onClose, isAlbanian, projectId }) => {
  const [project, setProject] = useState(null);

  useEffect(() => {
    if (!projectId || projectsData.length === 0) return;

    const foundProject = projectsData.find(
      (p) => String(p.project_id) === String(projectId)
    );

    if (foundProject) {
      setProject(foundProject);
    } else {
      console.error(`Project with ID ${projectId} not found`);
    }
  }, [projectId]);

  if (!project) {
    return null; 
  }

  return (
    <div className={`drawerproject ${isOpen ? "open" : ""}`}>
      <button className="drawerproject-close" onClick={onClose}>
        &times;
      </button>
      <div className="drawerproject-content">
        <h1 className="drawerprojectspecific">
          {isAlbanian ? "SPECIFIKIMET E PROJEKTIT" : "PROJECT SPECIFICATIONS"}
        </h1>
      </div>
      <div className="drawer-first-row">
        <div className="drawer-first-row-group">
          <h2>{isAlbanian ? "VITI" : "YEAR"}</h2>
          <p>{project.box_one}</p>
        </div>
        <div className="drawer-first-row-second-group">
          <h2>{isAlbanian ? "SIP. E NDËRTIMIT" : "BUILDING AREA"}</h2>
          <p>{project.box_two}</p>
        </div>
      </div>
      <div className="drawer-first-row">
        <div className="drawer-first-row-group">
          <h2>{isAlbanian ? "SHKALLË" : "SCALE"}</h2>
          <p>{project.box_three}</p>
        </div>
        <div className="drawer-first-row-second-group">
          <h2>{isAlbanian ? "KATET" : "FLOORS"}</h2>
          <p>{project.box_four}</p>
        </div>
      </div>
      {project.projectType === "Hotel" ? (
        <>
          <div className="drawer-first-row">
            <div className="drawer-first-row-group">
              <h2>{isAlbanian ? "NR. I DHOMAVE" : "NR. OF ROOMS"}</h2>
              <p>{project.box_five}</p>
            </div>
            <div className="drawer-first-row-second-group">
              <h2>{isAlbanian ? "NR. I PARKIMEVE" : "NR. OF CAR POST"}</h2>
              <p>{project.box_seven}</p>
            </div>
          </div>
          <div className="drawer-first-row">
            <div className="drawer-first-row-group"></div>
            <div className="drawer-first-row-second-group"></div>
          </div>
        </>
      ) : (
        <>
          <div className="drawer-first-row">
            <div className="drawer-first-row-group">
              <h2>{isAlbanian ? "NR. I APARTAMENTEVE" : "NR. APARTMENTS"}</h2>
              <p>{project.box_five}</p>
            </div>
            <div className="drawer-first-row-second-group">
              <h2>
                {isAlbanian ? "NR. I NJËSIVE TREGTARE" : "NR. SERVICE UNITS"}
              </h2>
              <p>{project.box_six}</p>
            </div>
          </div>
          <div className="drawer-first-row">
            <div className="drawer-first-row-group">
              <h2>{isAlbanian ? "NR. I PARKIMEVE" : "NR. OF CAR POST"}</h2>
              <p>{project.box_seven}</p>
            </div>
            <div className="drawer-first-row-second-group">
              <p>{project.box_eight}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DrawerProject;
